export default "__VITE_ASSET__BLDqtWAa__"